import {Vue} from "ui.vue";

export default {
	name: "MainPage",
	data() {
		return {
			commonPagination: {},
			commonLoad: {
				articlesList: false,
				newsList: false
			},
			newsListPageSize: 0,

			nextArticles: [],
			nextNews: [],
			cards: {
				article: 1,
				article_no_pic: 1,
				news: 1,
				news_no_pic: 1,
			},

			currentMobileTab: 'articles',

			currentHash: '',

			articleLineHeight: 0,
			visibleNewsLength: 0,
		};
	},
	created() {
		this.commonPagination = {
			articlesList: this.list.articles.data.PAGINATION,
			newsList: this.list.news.data.PAGINATION
		};

		this.commonPagination.articlesList.shownItems = this.list.articles.data.ITEMS.length;
		this.commonPagination.newsList.shownItems = this.list.news.data.ITEMS.length;

		this.newsListPageSize = this.commonPagination.newsList.pageSize;

		this.currentHash = window.location.href.split('#').pop();
		if (this.currentHash === 'news') {
			this.onMobileTabSelect(this.currentHash);
		}
	},
	mounted() {
		setTimeout(() => {
			this.updateNewsWrapHeight();
		}, 10);
	},
	methods: {
		onMobileTabSelect(tab) {
			this.currentMobileTab = tab;
		},
		onMobileSort(ref, {code, order}) {
			if (this.$refs[ref]) {
				this.$refs[ref].onSort(code, order);
			}
		},
		onChangeCommonPage({code, pageNumber, pageParam}) {
			this.onChangePage(code, {
				pageNumber: pageNumber,
				isMoreLink: true,
				pageParam: pageParam
			});
		},
		onChangePage(ref, data) {
			if (this.$refs[ref]) {
				this.$set(this.commonLoad, ref, true);
				this.$refs[ref].changePage(data);
			}
		},
		onNextCommonPage({code}) {
			this.prepareStepSize();
			setTimeout(() => {
				this.onNextPage(code);
			}, 10);
		},
		onNextPage(ref) {
			if (this.$refs[ref]) {
				this.$set(this.commonLoad, ref, true);
				this.$refs[ref].nextPage();
			}
		},
		onPageLoaded(ref, {items, pagination, shownItems}) {
			this.$set(pagination, "shownItems", shownItems);

			this.$set(this.commonPagination, ref, pagination);
			this.$set(this.commonLoad, ref, false);
		},
		onNextPageSize(ref, {items}) {
			if (ref === 'articlesList') {
				this.nextArticles = items;
			} else if (ref === 'newsList') {
				this.nextNews = items;
			}

			this.updateNewsWrapHeight();
		},
		prepareStepSize() {
			let nextArticlesStep = 0,
				nextNewsStep = 0;

			for (let i in this.nextArticles) {
				let koeff = this.nextArticles[i].PREVIEW_PICTURE ? this.cards.article : this.cards.article_no_pic;
				nextArticlesStep += koeff;
			}

			let newsListPageSize = 0;
			for (let i in this.nextNews) {
				let koeff = this.nextNews[i].PREVIEW_PICTURE ? this.cards.news : this.cards.news_no_pic;

				// 0.1 - погрешность расчетов, из-за баннеров и разного размера текстов
				// if (nextNewsStep + koeff > nextArticlesStep + 0.1) {
				// 	break;
				// }

				nextNewsStep += koeff;
				newsListPageSize = parseInt(i) + 1;
			}

			this.newsListPageSize = newsListPageSize;
		},
		updateNewsWrapHeight() {


			setTimeout(() => {
				this.articleLineHeight = this.$refs.articleLine.scrollHeight;

				this.getNewsElements();
			}, 10);
		},
		getNewsElements() {
			this.visibleNewsLength = 0;

			let commonElementsHiddenHeight = 35;
			let elemsHidden = this.$refs.newsLineHidden.childNodes;

			for (let i = 0; i < elemsHidden.length; i++) {
				if( (commonElementsHiddenHeight + elemsHidden[i].scrollHeight) > this.articleLineHeight ) {
					break;
				} else {
					commonElementsHiddenHeight += elemsHidden[i].scrollHeight;
					this.visibleNewsLength = i;
				}
			}
		}
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases(this.locPrefix);
		},
	},
};
